<template>
    <div>
        <v-subheader>HR</v-subheader>
            <v-list-item link :to="'/hr/dashboard'">
                <v-list-item-icon>
                  <!-- <v-icon>mdi-home-analytics</v-icon> -->
                  <v-icon>mdi-home-analytics</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Dashboard</v-list-item-title>
            </v-list-item>
            <v-list-item link :to="'/hr/manage/people'">
                <v-list-item-icon>
                  <v-icon>mdi-account-multiple</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Manage People</v-list-item-title>
            </v-list-item>
            <!-- <v-list-item link :to="'/hr/manage/people2'">
                <v-list-item-icon>
                  <v-icon>mdi-account-multiple</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Manage People v2</v-list-item-title>
            </v-list-item> -->
            <v-list-item link :to="'/hr/manage/spaces'">
                <v-list-item-icon>
                  <v-icon>mdi-domain</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Room Assignments</v-list-item-title>
            </v-list-item>
            <v-divider class="mb-3 mt-2"></v-divider>
        <v-subheader>Actions</v-subheader>
            <v-list-item link :to="'/action/new/person'">
                <v-list-item-icon>
                  <!-- <v-icon>mdi-home-analytics</v-icon> -->
                  <v-icon>mdi-account-plus</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Add Person</v-list-item-title>
            </v-list-item>
            <v-list-item link :to="'/action/edit/person'">
                <v-list-item-icon>
                  <v-icon>mdi-account-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Update Person</v-list-item-title>
            </v-list-item>
            <!-- Consider removing this and just having it as an option in update -->
            <!-- <v-list-item link :to="'/action/remove/person'">
                <v-list-item-icon>
                  <v-icon>mdi-account-remove</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Remove Person</v-list-item-title>
            </v-list-item> -->
            <v-divider class="mb-3 mt-2"></v-divider>
        <!-- <v-subheader>People</v-subheader>
            <v-list-item link :to="'/reservations/stats'">
              <v-list-item-icon>
                <v-icon>mdi-home-analytics</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Stats</v-list-item-title>
            </v-list-item>
            <v-divider class="mb-3 mt-2"></v-divider> -->
    </div>
</template>

<script>

export default {
  name: 'MitMenuHR',
  components: {
  },
  props: {
    userModel: Object
  },
  data() {
      return {
        buildings:[],
      }
  }
}
</script>

<style lang="scss" scoped>
</style>
